import type { ResolveInviteResponseDto } from "@service/network/supplier/dto/resolve-invite-response.dto";

import { ccfApiClient } from "../../../../../shared/api/api-clients";
import {
  CommitAccountSelectionResponse,
  CreateAccountBody,
  CreateAccountResponse,
  ForwardInviteBody,
} from "../../../public/supplier-types";

// Public front-door endpoints — ungated; work unauthenticated (no auth header set).

export const resolveInvite = async (connectionRequestId: string, token: string): Promise<ResolveInviteResponseDto> => {
  const response = await ccfApiClient.get<ResolveInviteResponseDto>(
    `network/supplier/registration/${connectionRequestId}/${token}`
  );
  return response.data;
};

export const createAccount = async (body: CreateAccountBody): Promise<CreateAccountResponse> => {
  const response = await ccfApiClient.post<CreateAccountResponse>("network/supplier/registration", body);
  return response.data;
};

export const forwardInvite = async (body: ForwardInviteBody): Promise<void> => {
  await ccfApiClient.post(`network/supplier/registration/${body.connectionRequestId}/${body.token}/forward-invite`, {
    name: body.name,
    email: body.email,
  });
};

// Fails open server-side, so this never errors.
export const getIndustries = async (): Promise<{ value: number; label: string }[]> => {
  const response = await ccfApiClient.get<{ value: number; label: string }[]>(
    "network/supplier/registration/industries"
  );
  return response.data;
};

// Authenticated endpoints — require a bearer token on ccfApiClient, set by UserProvider. Guarded
// server-side to the invite's supplierEmail; root classification is enforced server-side too.

// The account count can only be decided reliably post-login, so this repeats the public
// resolveInvite's CONNECTION_READY / ACCOUNT_SELECTION decision, now with rootAccounts populated.
export const resolveAsAuthenticated = async (connectionRequestId: string): Promise<ResolveInviteResponseDto> => {
  const response = await ccfApiClient.post<ResolveInviteResponseDto>(
    `network/supplier/account-selection/${connectionRequestId}/resolve`
  );
  return response.data;
};

export const commitAccountSelection = async (
  connectionRequestId: string,
  accountId: string
): Promise<CommitAccountSelectionResponse> => {
  const response = await ccfApiClient.post<CommitAccountSelectionResponse>(
    `network/supplier/account-selection/${connectionRequestId}/commit`,
    { accountId }
  );
  return response.data;
};
